import { render, staticRenderFns } from "./StudentsPage.vue?vue&type=template&id=0f037c3f&scoped=true"
import script from "./StudentsPage.vue?vue&type=script&lang=js"
export * from "./StudentsPage.vue?vue&type=script&lang=js"
import style0 from "./StudentsPage.vue?vue&type=style&index=0&id=0f037c3f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f037c3f",
  null
  
)

export default component.exports